import { observer } from "mobx-react-lite";
import React from "react";
import { useStore } from "../../../../helpers";
import { toJS } from "mobx";
import { DataTable } from "../../../../components-new/DataTable/DataTable";

export const RequestTypeTable = observer(() => {
  const { serviceRequestsStore } = useStore();
  const { meta } = serviceRequestsStore;
  const metadata = toJS(meta);

  return (
    <div>
      <DataTable data={metadata?.type ?? []} />
    </div>
  );
});
